import { ForecastWeather } from "../interfaces/ForecastWeather";

export const mockForecast: ForecastWeather = {
	location: {
		name: "Sao Paulo",
		region: "Sao Paulo",
		country: "Brazil",
		lat: -23.53,
		lon: -46.62,
		tz_id: "America/Sao_Paulo",
		localtime_epoch: 1688130721,
		localtime: "2023-06-30 10:12",
	},
	current: {
		last_updated_epoch: 1688130000,
		last_updated: "2023-06-30 10:00",
		temp_c: 17,
		temp_f: 62.6,
		is_day: 1,
		condition: {
			text: "Partly cloudy",
			icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
			code: 1003,
		},
		wind_mph: 9.4,
		wind_kph: 15.1,
		wind_degree: 90,
		wind_dir: "E",
		pressure_mb: 1026,
		pressure_in: 30.3,
		precip_mm: 0,
		precip_in: 0,
		humidity: 77,
		cloud: 75,
		feelslike_c: 17,
		feelslike_f: 62.6,
		vis_km: 8,
		vis_miles: 4,
		uv: 5,
		gust_mph: 7.2,
		gust_kph: 11.5,
		air_quality: {
			co: 654,
			no2: 32.599998474121094,
			o3: 29.299999237060547,
			so2: 29.299999237060547,
			pm2_5: 17.299999237060547,
			pm10: 32,
			"us-epa-index": 2,
			"gb-defra-index": 2,
		},
	},
	forecast: {
		forecastday: [
			{
				date: "2023-07-03",
				date_epoch: 1688083200,
				day: {
					maxtemp_c: 23.3,
					maxtemp_f: 73.9,
					mintemp_c: 14.3,
					mintemp_f: 57.7,
					avgtemp_c: 17.8,
					avgtemp_f: 64,
					maxwind_mph: 8.9,
					maxwind_kph: 14.4,
					totalprecip_mm: 0.3,
					totalprecip_in: 0.01,
					totalsnow_cm: 0,
					avgvis_km: 10,
					avgvis_miles: 6,
					avghumidity: 77,
					daily_will_it_rain: 0,
					daily_chance_of_rain: 67,
					daily_will_it_snow: 0,
					daily_chance_of_snow: 0,
					condition: {
						text: "Patchy rain possible",
						icon: "//cdn.weatherapi.com/weather/64x64/day/176.png",
						code: 1063,
					},
					uv: 4,
				},
				astro: {
					sunrise: "06:49 AM",
					sunset: "05:32 PM",
					moonrise: "02:46 PM",
					moonset: "03:42 AM",
					moon_phase: "Waxing Gibbous",
					moon_illumination: "84",
					is_moon_up: 1,
					is_sun_up: 0,
				},
				hour: [
					{
						time_epoch: 1688094000,
						time: "2023-06-30 00:00",
						temp_c: 15.5,
						temp_f: 59.9,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 7.8,
						wind_kph: 12.6,
						wind_degree: 127,
						wind_dir: "SE",
						pressure_mb: 1025,
						pressure_in: 30.27,
						precip_mm: 0,
						precip_in: 0,
						humidity: 88,
						cloud: 80,
						feelslike_c: 15.5,
						feelslike_f: 59.9,
						windchill_c: 15.5,
						windchill_f: 59.9,
						heatindex_c: 15.5,
						heatindex_f: 59.9,
						dewpoint_c: 13.4,
						dewpoint_f: 56.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 10.1,
						gust_kph: 16.2,
						uv: 1,
					},
					{
						time_epoch: 1688097600,
						time: "2023-06-30 01:00",
						temp_c: 15.5,
						temp_f: 59.9,
						is_day: 0,
						condition: {
							text: "Patchy rain possible",
							icon: "//cdn.weatherapi.com/weather/64x64/night/176.png",
							code: 1063,
						},
						wind_mph: 7.2,
						wind_kph: 11.5,
						wind_degree: 129,
						wind_dir: "SE",
						pressure_mb: 1025,
						pressure_in: 30.25,
						precip_mm: 0.1,
						precip_in: 0,
						humidity: 88,
						cloud: 86,
						feelslike_c: 15.5,
						feelslike_f: 59.9,
						windchill_c: 15.5,
						windchill_f: 59.9,
						heatindex_c: 15.5,
						heatindex_f: 59.9,
						dewpoint_c: 13.6,
						dewpoint_f: 56.5,
						will_it_rain: 1,
						chance_of_rain: 81,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.2,
						gust_kph: 14.8,
						uv: 1,
					},
					{
						time_epoch: 1688101200,
						time: "2023-06-30 02:00",
						temp_c: 15.1,
						temp_f: 59.2,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 6.9,
						wind_kph: 11.2,
						wind_degree: 127,
						wind_dir: "SE",
						pressure_mb: 1024,
						pressure_in: 30.24,
						precip_mm: 0,
						precip_in: 0,
						humidity: 89,
						cloud: 80,
						feelslike_c: 15.1,
						feelslike_f: 59.2,
						windchill_c: 15.1,
						windchill_f: 59.2,
						heatindex_c: 15.1,
						heatindex_f: 59.2,
						dewpoint_c: 13.4,
						dewpoint_f: 56.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.6,
						gust_kph: 15.5,
						uv: 1,
					},
					{
						time_epoch: 1688104800,
						time: "2023-06-30 03:00",
						temp_c: 14.6,
						temp_f: 58.3,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 6.5,
						wind_kph: 10.4,
						wind_degree: 119,
						wind_dir: "ESE",
						pressure_mb: 1024,
						pressure_in: 30.23,
						precip_mm: 0,
						precip_in: 0,
						humidity: 88,
						cloud: 75,
						feelslike_c: 14.1,
						feelslike_f: 57.4,
						windchill_c: 14.1,
						windchill_f: 57.4,
						heatindex_c: 14.6,
						heatindex_f: 58.3,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 10.1,
						gust_kph: 16.2,
						uv: 1,
					},
					{
						time_epoch: 1688108400,
						time: "2023-06-30 04:00",
						temp_c: 14.5,
						temp_f: 58.1,
						is_day: 0,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
							code: 1003,
						},
						wind_mph: 6.3,
						wind_kph: 10.1,
						wind_degree: 115,
						wind_dir: "ESE",
						pressure_mb: 1023,
						pressure_in: 30.22,
						precip_mm: 0,
						precip_in: 0,
						humidity: 88,
						cloud: 53,
						feelslike_c: 14,
						feelslike_f: 57.2,
						windchill_c: 14,
						windchill_f: 57.2,
						heatindex_c: 14.5,
						heatindex_f: 58.1,
						dewpoint_c: 12.5,
						dewpoint_f: 54.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.8,
						gust_kph: 15.8,
						uv: 1,
					},
					{
						time_epoch: 1688112000,
						time: "2023-06-30 05:00",
						temp_c: 14.2,
						temp_f: 57.6,
						is_day: 0,
						condition: {
							text: "Patchy rain possible",
							icon: "//cdn.weatherapi.com/weather/64x64/night/176.png",
							code: 1063,
						},
						wind_mph: 5.8,
						wind_kph: 9.4,
						wind_degree: 119,
						wind_dir: "ESE",
						pressure_mb: 1024,
						pressure_in: 30.23,
						precip_mm: 0.1,
						precip_in: 0,
						humidity: 89,
						cloud: 89,
						feelslike_c: 13.7,
						feelslike_f: 56.7,
						windchill_c: 13.7,
						windchill_f: 56.7,
						heatindex_c: 14.2,
						heatindex_f: 57.6,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 1,
						chance_of_rain: 77,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.6,
						gust_kph: 15.5,
						uv: 1,
					},
					{
						time_epoch: 1688115600,
						time: "2023-06-30 06:00",
						temp_c: 13.7,
						temp_f: 56.7,
						is_day: 0,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
							code: 1003,
						},
						wind_mph: 5.6,
						wind_kph: 9,
						wind_degree: 122,
						wind_dir: "ESE",
						pressure_mb: 1024,
						pressure_in: 30.24,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 32,
						feelslike_c: 13.2,
						feelslike_f: 55.8,
						windchill_c: 13.2,
						windchill_f: 55.8,
						heatindex_c: 13.7,
						heatindex_f: 56.7,
						dewpoint_c: 12.2,
						dewpoint_f: 54,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.6,
						gust_kph: 15.5,
						uv: 1,
					},
					{
						time_epoch: 1688119200,
						time: "2023-06-30 07:00",
						temp_c: 15.1,
						temp_f: 59.2,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 6.3,
						wind_kph: 10.1,
						wind_degree: 118,
						wind_dir: "ESE",
						pressure_mb: 1025,
						pressure_in: 30.26,
						precip_mm: 0,
						precip_in: 0,
						humidity: 86,
						cloud: 33,
						feelslike_c: 15.1,
						feelslike_f: 59.2,
						windchill_c: 15.1,
						windchill_f: 59.2,
						heatindex_c: 15.1,
						heatindex_f: 59.2,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.3,
						gust_kph: 13.3,
						uv: 5,
					},
					{
						time_epoch: 1688122800,
						time: "2023-06-30 08:00",
						temp_c: 16.9,
						temp_f: 62.4,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 6.9,
						wind_kph: 11.2,
						wind_degree: 105,
						wind_dir: "ESE",
						pressure_mb: 1025,
						pressure_in: 30.27,
						precip_mm: 0,
						precip_in: 0,
						humidity: 77,
						cloud: 28,
						feelslike_c: 16.9,
						feelslike_f: 62.4,
						windchill_c: 16.9,
						windchill_f: 62.4,
						heatindex_c: 16.9,
						heatindex_f: 62.4,
						dewpoint_c: 12.8,
						dewpoint_f: 55,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.1,
						gust_kph: 13,
						uv: 5,
					},
					{
						time_epoch: 1688126400,
						time: "2023-06-30 09:00",
						temp_c: 18.6,
						temp_f: 65.5,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 6.9,
						wind_kph: 11.2,
						wind_degree: 103,
						wind_dir: "ESE",
						pressure_mb: 1026,
						pressure_in: 30.29,
						precip_mm: 0,
						precip_in: 0,
						humidity: 69,
						cloud: 19,
						feelslike_c: 18.6,
						feelslike_f: 65.5,
						windchill_c: 18.6,
						windchill_f: 65.5,
						heatindex_c: 18.6,
						heatindex_f: 65.5,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.1,
						gust_kph: 13,
						uv: 5,
					},
					{
						time_epoch: 1688130000,
						time: "2023-06-30 10:00",
						temp_c: 19.9,
						temp_f: 67.8,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 6.3,
						wind_kph: 10.1,
						wind_degree: 105,
						wind_dir: "ESE",
						pressure_mb: 1025,
						pressure_in: 30.27,
						precip_mm: 0,
						precip_in: 0,
						humidity: 62,
						cloud: 41,
						feelslike_c: 19.9,
						feelslike_f: 67.8,
						windchill_c: 19.9,
						windchill_f: 67.8,
						heatindex_c: 19.9,
						heatindex_f: 67.8,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 7.2,
						gust_kph: 11.5,
						uv: 5,
					},
					{
						time_epoch: 1688133600,
						time: "2023-06-30 11:00",
						temp_c: 21.9,
						temp_f: 71.4,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 5.6,
						wind_kph: 9,
						wind_degree: 111,
						wind_dir: "ESE",
						pressure_mb: 1024,
						pressure_in: 30.24,
						precip_mm: 0,
						precip_in: 0,
						humidity: 56,
						cloud: 19,
						feelslike_c: 21.9,
						feelslike_f: 71.4,
						windchill_c: 21.9,
						windchill_f: 71.4,
						heatindex_c: 24.5,
						heatindex_f: 76.1,
						dewpoint_c: 12.8,
						dewpoint_f: 55,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 6.5,
						gust_kph: 10.4,
						uv: 6,
					},
					{
						time_epoch: 1688137200,
						time: "2023-06-30 12:00",
						temp_c: 22.6,
						temp_f: 72.7,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 4.5,
						wind_kph: 7.2,
						wind_degree: 123,
						wind_dir: "ESE",
						pressure_mb: 1023,
						pressure_in: 30.2,
						precip_mm: 0,
						precip_in: 0,
						humidity: 53,
						cloud: 50,
						feelslike_c: 24.6,
						feelslike_f: 76.3,
						windchill_c: 22.6,
						windchill_f: 72.7,
						heatindex_c: 24.6,
						heatindex_f: 76.3,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.1,
						gust_kph: 8.3,
						uv: 6,
					},
					{
						time_epoch: 1688140800,
						time: "2023-06-30 13:00",
						temp_c: 23,
						temp_f: 73.4,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 5.1,
						wind_kph: 8.3,
						wind_degree: 149,
						wind_dir: "SSE",
						pressure_mb: 1022,
						pressure_in: 30.17,
						precip_mm: 0,
						precip_in: 0,
						humidity: 51,
						cloud: 44,
						feelslike_c: 24.8,
						feelslike_f: 76.6,
						windchill_c: 23,
						windchill_f: 73.4,
						heatindex_c: 24.8,
						heatindex_f: 76.6,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.8,
						gust_kph: 9.4,
						uv: 6,
					},
					{
						time_epoch: 1688144400,
						time: "2023-06-30 14:00",
						temp_c: 22.4,
						temp_f: 72.3,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 7.6,
						wind_kph: 12.2,
						wind_degree: 159,
						wind_dir: "SSE",
						pressure_mb: 1021,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 54,
						cloud: 37,
						feelslike_c: 24.6,
						feelslike_f: 76.3,
						windchill_c: 22.4,
						windchill_f: 72.3,
						heatindex_c: 24.6,
						heatindex_f: 76.3,
						dewpoint_c: 12.6,
						dewpoint_f: 54.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.7,
						gust_kph: 14,
						uv: 6,
					},
					{
						time_epoch: 1688148000,
						time: "2023-06-30 15:00",
						temp_c: 21.1,
						temp_f: 70,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 9.8,
						wind_kph: 15.8,
						wind_degree: 157,
						wind_dir: "SSE",
						pressure_mb: 1021,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 65,
						cloud: 25,
						feelslike_c: 21.1,
						feelslike_f: 70,
						windchill_c: 21.1,
						windchill_f: 70,
						heatindex_c: 24.4,
						heatindex_f: 75.9,
						dewpoint_c: 14.2,
						dewpoint_f: 57.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 11.4,
						gust_kph: 18.4,
						uv: 6,
					},
					{
						time_epoch: 1688151600,
						time: "2023-06-30 16:00",
						temp_c: 20,
						temp_f: 68,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 9.2,
						wind_kph: 14.8,
						wind_degree: 153,
						wind_dir: "SSE",
						pressure_mb: 1022,
						pressure_in: 30.17,
						precip_mm: 0,
						precip_in: 0,
						humidity: 74,
						cloud: 15,
						feelslike_c: 20,
						feelslike_f: 68,
						windchill_c: 20,
						windchill_f: 68,
						heatindex_c: 20,
						heatindex_f: 68,
						dewpoint_c: 15.3,
						dewpoint_f: 59.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 10.5,
						gust_kph: 16.9,
						uv: 6,
					},
					{
						time_epoch: 1688155200,
						time: "2023-06-30 17:00",
						temp_c: 18.1,
						temp_f: 64.6,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 7.4,
						wind_kph: 11.9,
						wind_degree: 152,
						wind_dir: "SSE",
						pressure_mb: 1022,
						pressure_in: 30.18,
						precip_mm: 0,
						precip_in: 0,
						humidity: 81,
						cloud: 46,
						feelslike_c: 18.1,
						feelslike_f: 64.6,
						windchill_c: 18.1,
						windchill_f: 64.6,
						heatindex_c: 18.1,
						heatindex_f: 64.6,
						dewpoint_c: 14.8,
						dewpoint_f: 58.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.5,
						gust_kph: 13.7,
						uv: 5,
					},
					{
						time_epoch: 1688158800,
						time: "2023-06-30 18:00",
						temp_c: 17.5,
						temp_f: 63.5,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 6.5,
						wind_kph: 10.4,
						wind_degree: 147,
						wind_dir: "SSE",
						pressure_mb: 1023,
						pressure_in: 30.2,
						precip_mm: 0,
						precip_in: 0,
						humidity: 84,
						cloud: 70,
						feelslike_c: 17.5,
						feelslike_f: 63.5,
						windchill_c: 17.5,
						windchill_f: 63.5,
						heatindex_c: 17.5,
						heatindex_f: 63.5,
						dewpoint_c: 14.8,
						dewpoint_f: 58.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 7.4,
						gust_kph: 11.9,
						uv: 1,
					},
					{
						time_epoch: 1688162400,
						time: "2023-06-30 19:00",
						temp_c: 17.2,
						temp_f: 63,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 6.3,
						wind_kph: 10.1,
						wind_degree: 148,
						wind_dir: "SSE",
						pressure_mb: 1023,
						pressure_in: 30.21,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 85,
						feelslike_c: 17.2,
						feelslike_f: 63,
						windchill_c: 17.2,
						windchill_f: 63,
						heatindex_c: 17.2,
						heatindex_f: 63,
						dewpoint_c: 14.7,
						dewpoint_f: 58.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 7.2,
						gust_kph: 11.5,
						uv: 1,
					},
					{
						time_epoch: 1688166000,
						time: "2023-06-30 20:00",
						temp_c: 16.2,
						temp_f: 61.2,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 5.1,
						wind_kph: 8.3,
						wind_degree: 144,
						wind_dir: "SE",
						pressure_mb: 1024,
						pressure_in: 30.22,
						precip_mm: 0,
						precip_in: 0,
						humidity: 86,
						cloud: 87,
						feelslike_c: 16.2,
						feelslike_f: 61.2,
						windchill_c: 16.2,
						windchill_f: 61.2,
						heatindex_c: 16.2,
						heatindex_f: 61.2,
						dewpoint_c: 13.8,
						dewpoint_f: 56.8,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 6.3,
						gust_kph: 10.1,
						uv: 1,
					},
					{
						time_epoch: 1688169600,
						time: "2023-06-30 21:00",
						temp_c: 16.1,
						temp_f: 61,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 4.5,
						wind_kph: 7.2,
						wind_degree: 134,
						wind_dir: "SE",
						pressure_mb: 1024,
						pressure_in: 30.23,
						precip_mm: 0,
						precip_in: 0,
						humidity: 86,
						cloud: 86,
						feelslike_c: 16.1,
						feelslike_f: 61,
						windchill_c: 16.1,
						windchill_f: 61,
						heatindex_c: 16.1,
						heatindex_f: 61,
						dewpoint_c: 13.7,
						dewpoint_f: 56.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.4,
						gust_kph: 8.6,
						uv: 1,
					},
					{
						time_epoch: 1688173200,
						time: "2023-06-30 22:00",
						temp_c: 15.7,
						temp_f: 60.3,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.8,
						wind_kph: 6.1,
						wind_degree: 118,
						wind_dir: "ESE",
						pressure_mb: 1024,
						pressure_in: 30.23,
						precip_mm: 0,
						precip_in: 0,
						humidity: 86,
						cloud: 84,
						feelslike_c: 15.7,
						feelslike_f: 60.3,
						windchill_c: 15.7,
						windchill_f: 60.3,
						heatindex_c: 15.7,
						heatindex_f: 60.3,
						dewpoint_c: 13.3,
						dewpoint_f: 55.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.7,
						gust_kph: 7.6,
						uv: 1,
					},
					{
						time_epoch: 1688176800,
						time: "2023-06-30 23:00",
						temp_c: 16,
						temp_f: 60.8,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 4,
						wind_kph: 6.5,
						wind_degree: 101,
						wind_dir: "ESE",
						pressure_mb: 1023,
						pressure_in: 30.21,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 78,
						feelslike_c: 16,
						feelslike_f: 60.8,
						windchill_c: 16,
						windchill_f: 60.8,
						heatindex_c: 16,
						heatindex_f: 60.8,
						dewpoint_c: 13.6,
						dewpoint_f: 56.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.7,
						gust_kph: 7.6,
						uv: 1,
					},
				],
			},
			{
				date: "2023-07-04",
				date_epoch: 1688169600,
				day: {
					maxtemp_c: 25.5,
					maxtemp_f: 77.9,
					mintemp_c: 13.4,
					mintemp_f: 56.1,
					avgtemp_c: 18.9,
					avgtemp_f: 66,
					maxwind_mph: 5.8,
					maxwind_kph: 9.4,
					totalprecip_mm: 0,
					totalprecip_in: 0,
					totalsnow_cm: 0,
					avgvis_km: 9,
					avgvis_miles: 5,
					avghumidity: 72,
					daily_will_it_rain: 0,
					daily_chance_of_rain: 0,
					daily_will_it_snow: 0,
					daily_chance_of_snow: 0,
					condition: {
						text: "Sunny",
						icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
						code: 1000,
					},
					uv: 5,
				},
				astro: {
					sunrise: "06:49 AM",
					sunset: "05:32 PM",
					moonrise: "03:38 PM",
					moonset: "04:47 AM",
					moon_phase: "Waxing Gibbous",
					moon_illumination: "92",
					is_moon_up: 1,
					is_sun_up: 0,
				},
				hour: [
					{
						time_epoch: 1688180400,
						time: "2023-07-01 00:00",
						temp_c: 15.1,
						temp_f: 59.2,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.8,
						wind_kph: 6.1,
						wind_degree: 88,
						wind_dir: "E",
						pressure_mb: 1023,
						pressure_in: 30.2,
						precip_mm: 0,
						precip_in: 0,
						humidity: 87,
						cloud: 73,
						feelslike_c: 15.1,
						feelslike_f: 59.2,
						windchill_c: 15.1,
						windchill_f: 59.2,
						heatindex_c: 15.1,
						heatindex_f: 59.2,
						dewpoint_c: 12.9,
						dewpoint_f: 55.2,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.1,
						gust_kph: 8.3,
						uv: 1,
					},
					{
						time_epoch: 1688184000,
						time: "2023-07-01 01:00",
						temp_c: 14.5,
						temp_f: 58.1,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.4,
						wind_kph: 5.4,
						wind_degree: 83,
						wind_dir: "E",
						pressure_mb: 1022,
						pressure_in: 30.19,
						precip_mm: 0,
						precip_in: 0,
						humidity: 89,
						cloud: 75,
						feelslike_c: 14.8,
						feelslike_f: 58.6,
						windchill_c: 14.8,
						windchill_f: 58.6,
						heatindex_c: 14.5,
						heatindex_f: 58.1,
						dewpoint_c: 12.6,
						dewpoint_f: 54.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.9,
						gust_kph: 7.9,
						uv: 1,
					},
					{
						time_epoch: 1688187600,
						time: "2023-07-01 02:00",
						temp_c: 14.3,
						temp_f: 57.7,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.6,
						wind_kph: 5.8,
						wind_degree: 75,
						wind_dir: "ENE",
						pressure_mb: 1022,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 75,
						feelslike_c: 14.5,
						feelslike_f: 58.1,
						windchill_c: 14.5,
						windchill_f: 58.1,
						heatindex_c: 14.3,
						heatindex_f: 57.7,
						dewpoint_c: 12.6,
						dewpoint_f: 54.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.1,
						gust_kph: 8.3,
						uv: 1,
					},
					{
						time_epoch: 1688191200,
						time: "2023-07-01 03:00",
						temp_c: 14,
						temp_f: 57.2,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.4,
						wind_kph: 5.4,
						wind_degree: 69,
						wind_dir: "ENE",
						pressure_mb: 1021,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 69,
						feelslike_c: 14.2,
						feelslike_f: 57.6,
						windchill_c: 14.2,
						windchill_f: 57.6,
						heatindex_c: 14,
						heatindex_f: 57.2,
						dewpoint_c: 12.5,
						dewpoint_f: 54.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.9,
						gust_kph: 7.9,
						uv: 1,
					},
					{
						time_epoch: 1688194800,
						time: "2023-07-01 04:00",
						temp_c: 13.7,
						temp_f: 56.7,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.4,
						wind_kph: 5.4,
						wind_degree: 66,
						wind_dir: "ENE",
						pressure_mb: 1021,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 91,
						cloud: 65,
						feelslike_c: 13.9,
						feelslike_f: 57,
						windchill_c: 13.9,
						windchill_f: 57,
						heatindex_c: 13.7,
						heatindex_f: 56.7,
						dewpoint_c: 12.2,
						dewpoint_f: 54,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.9,
						gust_kph: 7.9,
						uv: 1,
					},
					{
						time_epoch: 1688198400,
						time: "2023-07-01 05:00",
						temp_c: 13.8,
						temp_f: 56.8,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 3.8,
						wind_kph: 6.1,
						wind_degree: 59,
						wind_dir: "ENE",
						pressure_mb: 1022,
						pressure_in: 30.16,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 65,
						feelslike_c: 13.8,
						feelslike_f: 56.8,
						windchill_c: 13.8,
						windchill_f: 56.8,
						heatindex_c: 13.8,
						heatindex_f: 56.8,
						dewpoint_c: 12.2,
						dewpoint_f: 54,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.6,
						gust_kph: 9,
						uv: 1,
					},
					{
						time_epoch: 1688202000,
						time: "2023-07-01 06:00",
						temp_c: 14.2,
						temp_f: 57.6,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 4,
						wind_kph: 6.5,
						wind_degree: 53,
						wind_dir: "NE",
						pressure_mb: 1022,
						pressure_in: 30.18,
						precip_mm: 0,
						precip_in: 0,
						humidity: 89,
						cloud: 66,
						feelslike_c: 14.2,
						feelslike_f: 57.6,
						windchill_c: 14.2,
						windchill_f: 57.6,
						heatindex_c: 14.2,
						heatindex_f: 57.6,
						dewpoint_c: 12.5,
						dewpoint_f: 54.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.4,
						gust_kph: 8.6,
						uv: 1,
					},
					{
						time_epoch: 1688205600,
						time: "2023-07-01 07:00",
						temp_c: 15.3,
						temp_f: 59.5,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 4,
						wind_kph: 6.5,
						wind_degree: 49,
						wind_dir: "NE",
						pressure_mb: 1022,
						pressure_in: 30.19,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 41,
						feelslike_c: 15.3,
						feelslike_f: 59.5,
						windchill_c: 15.3,
						windchill_f: 59.5,
						heatindex_c: 15.3,
						heatindex_f: 59.5,
						dewpoint_c: 12.8,
						dewpoint_f: 55,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.7,
						gust_kph: 7.6,
						uv: 5,
					},
					{
						time_epoch: 1688209200,
						time: "2023-07-01 08:00",
						temp_c: 17,
						temp_f: 62.6,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 3.6,
						wind_kph: 5.8,
						wind_degree: 51,
						wind_dir: "NE",
						pressure_mb: 1022,
						pressure_in: 30.19,
						precip_mm: 0,
						precip_in: 0,
						humidity: 76,
						cloud: 22,
						feelslike_c: 17,
						feelslike_f: 62.6,
						windchill_c: 17,
						windchill_f: 62.6,
						heatindex_c: 17,
						heatindex_f: 62.6,
						dewpoint_c: 12.8,
						dewpoint_f: 55,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4,
						gust_kph: 6.5,
						uv: 5,
					},
					{
						time_epoch: 1688212800,
						time: "2023-07-01 09:00",
						temp_c: 19.1,
						temp_f: 66.4,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 2.7,
						wind_kph: 4.3,
						wind_degree: 37,
						wind_dir: "NE",
						pressure_mb: 1022,
						pressure_in: 30.19,
						precip_mm: 0,
						precip_in: 0,
						humidity: 66,
						cloud: 3,
						feelslike_c: 19.1,
						feelslike_f: 66.4,
						windchill_c: 19.1,
						windchill_f: 66.4,
						heatindex_c: 19.1,
						heatindex_f: 66.4,
						dewpoint_c: 12.6,
						dewpoint_f: 54.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 3.1,
						gust_kph: 5,
						uv: 5,
					},
					{
						time_epoch: 1688216400,
						time: "2023-07-01 10:00",
						temp_c: 21.3,
						temp_f: 70.3,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 0.4,
						wind_kph: 0.7,
						wind_degree: 26,
						wind_dir: "NNE",
						pressure_mb: 1022,
						pressure_in: 30.17,
						precip_mm: 0,
						precip_in: 0,
						humidity: 57,
						cloud: 3,
						feelslike_c: 21.3,
						feelslike_f: 70.3,
						windchill_c: 21.3,
						windchill_f: 70.3,
						heatindex_c: 24.4,
						heatindex_f: 75.9,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.4,
						gust_kph: 0.7,
						uv: 6,
					},
					{
						time_epoch: 1688220000,
						time: "2023-07-01 11:00",
						temp_c: 24.5,
						temp_f: 76.1,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 2.5,
						wind_kph: 4,
						wind_degree: 228,
						wind_dir: "SW",
						pressure_mb: 1021,
						pressure_in: 30.14,
						precip_mm: 0,
						precip_in: 0,
						humidity: 51,
						cloud: 4,
						feelslike_c: 25.5,
						feelslike_f: 77.9,
						windchill_c: 24.5,
						windchill_f: 76.1,
						heatindex_c: 25.5,
						heatindex_f: 77.9,
						dewpoint_c: 13.7,
						dewpoint_f: 56.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.9,
						gust_kph: 4.7,
						uv: 6,
					},
					{
						time_epoch: 1688223600,
						time: "2023-07-01 12:00",
						temp_c: 24.7,
						temp_f: 76.5,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 3.8,
						wind_kph: 6.1,
						wind_degree: 236,
						wind_dir: "WSW",
						pressure_mb: 1019,
						pressure_in: 30.09,
						precip_mm: 0,
						precip_in: 0,
						humidity: 46,
						cloud: 9,
						feelslike_c: 25.5,
						feelslike_f: 77.9,
						windchill_c: 24.7,
						windchill_f: 76.5,
						heatindex_c: 25.5,
						heatindex_f: 77.9,
						dewpoint_c: 12.3,
						dewpoint_f: 54.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.5,
						gust_kph: 7.2,
						uv: 6,
					},
					{
						time_epoch: 1688227200,
						time: "2023-07-01 13:00",
						temp_c: 25.3,
						temp_f: 77.5,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 4.5,
						wind_kph: 7.2,
						wind_degree: 251,
						wind_dir: "WSW",
						pressure_mb: 1018,
						pressure_in: 30.05,
						precip_mm: 0,
						precip_in: 0,
						humidity: 41,
						cloud: 13,
						feelslike_c: 25.6,
						feelslike_f: 78.1,
						windchill_c: 25.3,
						windchill_f: 77.5,
						heatindex_c: 25.6,
						heatindex_f: 78.1,
						dewpoint_c: 11,
						dewpoint_f: 51.8,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.1,
						gust_kph: 8.3,
						uv: 7,
					},
					{
						time_epoch: 1688230800,
						time: "2023-07-01 14:00",
						temp_c: 25.8,
						temp_f: 78.4,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 5.6,
						wind_kph: 9,
						wind_degree: 252,
						wind_dir: "WSW",
						pressure_mb: 1017,
						pressure_in: 30.03,
						precip_mm: 0,
						precip_in: 0,
						humidity: 38,
						cloud: 9,
						feelslike_c: 25.8,
						feelslike_f: 78.4,
						windchill_c: 25.8,
						windchill_f: 78.4,
						heatindex_c: 25.8,
						heatindex_f: 78.4,
						dewpoint_c: 10.4,
						dewpoint_f: 50.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 6.5,
						gust_kph: 10.4,
						uv: 7,
					},
					{
						time_epoch: 1688234400,
						time: "2023-07-01 15:00",
						temp_c: 25.4,
						temp_f: 77.7,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 6.3,
						wind_kph: 10.1,
						wind_degree: 262,
						wind_dir: "W",
						pressure_mb: 1017,
						pressure_in: 30.02,
						precip_mm: 0,
						precip_in: 0,
						humidity: 39,
						cloud: 8,
						feelslike_c: 25.6,
						feelslike_f: 78.1,
						windchill_c: 25.4,
						windchill_f: 77.7,
						heatindex_c: 25.6,
						heatindex_f: 78.1,
						dewpoint_c: 10.5,
						dewpoint_f: 50.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 7.2,
						gust_kph: 11.5,
						uv: 7,
					},
					{
						time_epoch: 1688238000,
						time: "2023-07-01 16:00",
						temp_c: 24.1,
						temp_f: 75.4,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 5.4,
						wind_kph: 8.6,
						wind_degree: 260,
						wind_dir: "W",
						pressure_mb: 1017,
						pressure_in: 30.03,
						precip_mm: 0,
						precip_in: 0,
						humidity: 47,
						cloud: 7,
						feelslike_c: 25.2,
						feelslike_f: 77.4,
						windchill_c: 24.1,
						windchill_f: 75.4,
						heatindex_c: 25.2,
						heatindex_f: 77.4,
						dewpoint_c: 12.2,
						dewpoint_f: 54,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 6.3,
						gust_kph: 10.1,
						uv: 6,
					},
					{
						time_epoch: 1688241600,
						time: "2023-07-01 17:00",
						temp_c: 22.5,
						temp_f: 72.5,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 3.6,
						wind_kph: 5.8,
						wind_degree: 226,
						wind_dir: "SW",
						pressure_mb: 1018,
						pressure_in: 30.05,
						precip_mm: 0,
						precip_in: 0,
						humidity: 59,
						cloud: 7,
						feelslike_c: 24.7,
						feelslike_f: 76.5,
						windchill_c: 22.5,
						windchill_f: 72.5,
						heatindex_c: 24.7,
						heatindex_f: 76.5,
						dewpoint_c: 14.1,
						dewpoint_f: 57.4,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4,
						gust_kph: 6.5,
						uv: 6,
					},
					{
						time_epoch: 1688245200,
						time: "2023-07-01 18:00",
						temp_c: 21.8,
						temp_f: 71.2,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 3.8,
						wind_kph: 6.1,
						wind_degree: 178,
						wind_dir: "S",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 69,
						cloud: 6,
						feelslike_c: 21.8,
						feelslike_f: 71.2,
						windchill_c: 21.8,
						windchill_f: 71.2,
						heatindex_c: 24.5,
						heatindex_f: 76.1,
						dewpoint_c: 15.8,
						dewpoint_f: 60.4,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.5,
						gust_kph: 7.2,
						uv: 1,
					},
					{
						time_epoch: 1688248800,
						time: "2023-07-01 19:00",
						temp_c: 21.2,
						temp_f: 70.2,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 2.9,
						wind_kph: 4.7,
						wind_degree: 155,
						wind_dir: "SSE",
						pressure_mb: 1019,
						pressure_in: 30.1,
						precip_mm: 0,
						precip_in: 0,
						humidity: 75,
						cloud: 4,
						feelslike_c: 21.2,
						feelslike_f: 70.2,
						windchill_c: 21.2,
						windchill_f: 70.2,
						heatindex_c: 24.4,
						heatindex_f: 75.9,
						dewpoint_c: 16.7,
						dewpoint_f: 62.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 3.4,
						gust_kph: 5.4,
						uv: 1,
					},
					{
						time_epoch: 1688252400,
						time: "2023-07-01 20:00",
						temp_c: 17.8,
						temp_f: 64,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.8,
						wind_kph: 2.9,
						wind_degree: 154,
						wind_dir: "SSE",
						pressure_mb: 1019,
						pressure_in: 30.1,
						precip_mm: 0,
						precip_in: 0,
						humidity: 79,
						cloud: 2,
						feelslike_c: 17.8,
						feelslike_f: 64,
						windchill_c: 17.8,
						windchill_f: 64,
						heatindex_c: 17.8,
						heatindex_f: 64,
						dewpoint_c: 14.2,
						dewpoint_f: 57.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.5,
						gust_kph: 4,
						uv: 1,
					},
					{
						time_epoch: 1688256000,
						time: "2023-07-01 21:00",
						temp_c: 17.6,
						temp_f: 63.7,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.3,
						wind_kph: 2.2,
						wind_degree: 156,
						wind_dir: "SSE",
						pressure_mb: 1019,
						pressure_in: 30.1,
						precip_mm: 0,
						precip_in: 0,
						humidity: 82,
						cloud: 3,
						feelslike_c: 17.6,
						feelslike_f: 63.7,
						windchill_c: 17.6,
						windchill_f: 63.7,
						heatindex_c: 17.6,
						heatindex_f: 63.7,
						dewpoint_c: 14.5,
						dewpoint_f: 58.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 1.8,
						gust_kph: 2.9,
						uv: 1,
					},
					{
						time_epoch: 1688259600,
						time: "2023-07-01 22:00",
						temp_c: 17.2,
						temp_f: 63,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 0.7,
						wind_kph: 1.1,
						wind_degree: 85,
						wind_dir: "E",
						pressure_mb: 1019,
						pressure_in: 30.09,
						precip_mm: 0,
						precip_in: 0,
						humidity: 84,
						cloud: 3,
						feelslike_c: 17.2,
						feelslike_f: 63,
						windchill_c: 17.2,
						windchill_f: 63,
						heatindex_c: 17.2,
						heatindex_f: 63,
						dewpoint_c: 14.5,
						dewpoint_f: 58.1,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.9,
						gust_kph: 1.4,
						uv: 1,
					},
					{
						time_epoch: 1688263200,
						time: "2023-07-01 23:00",
						temp_c: 16.9,
						temp_f: 62.4,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 0.7,
						wind_kph: 1.1,
						wind_degree: 38,
						wind_dir: "NE",
						pressure_mb: 1019,
						pressure_in: 30.09,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 5,
						feelslike_c: 16.9,
						feelslike_f: 62.4,
						windchill_c: 16.9,
						windchill_f: 62.4,
						heatindex_c: 16.9,
						heatindex_f: 62.4,
						dewpoint_c: 14.4,
						dewpoint_f: 57.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.9,
						gust_kph: 1.4,
						uv: 1,
					},
				],
			},
			{
				date: "2023-07-05",
				date_epoch: 1688256000,
				day: {
					maxtemp_c: 22.8,
					maxtemp_f: 73,
					mintemp_c: 14.7,
					mintemp_f: 58.5,
					avgtemp_c: 17.7,
					avgtemp_f: 63.9,
					maxwind_mph: 11.2,
					maxwind_kph: 18,
					totalprecip_mm: 0.2,
					totalprecip_in: 0.01,
					totalsnow_cm: 0,
					avgvis_km: 10,
					avgvis_miles: 6,
					avghumidity: 77,
					daily_will_it_rain: 0,
					daily_chance_of_rain: 69,
					daily_will_it_snow: 0,
					daily_chance_of_snow: 0,
					condition: {
						text: "Patchy rain possible",
						icon: "//cdn.weatherapi.com/weather/64x64/day/176.png",
						code: 1063,
					},
					uv: 4,
				},
				astro: {
					sunrise: "06:49 AM",
					sunset: "05:32 PM",
					moonrise: "04:38 PM",
					moonset: "05:54 AM",
					moon_phase: "Waxing Gibbous",
					moon_illumination: "97",
					is_moon_up: 1,
					is_sun_up: 0,
				},
				hour: [
					{
						time_epoch: 1688266800,
						time: "2023-07-02 00:00",
						temp_c: 15.8,
						temp_f: 60.4,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 0.4,
						wind_kph: 0.7,
						wind_degree: 179,
						wind_dir: "S",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 86,
						cloud: 7,
						feelslike_c: 15.8,
						feelslike_f: 60.4,
						windchill_c: 15.8,
						windchill_f: 60.4,
						heatindex_c: 15.8,
						heatindex_f: 60.4,
						dewpoint_c: 13.5,
						dewpoint_f: 56.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.7,
						gust_kph: 1.1,
						uv: 1,
					},
					{
						time_epoch: 1688270400,
						time: "2023-07-02 01:00",
						temp_c: 15.7,
						temp_f: 60.3,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 0.2,
						wind_kph: 0.4,
						wind_degree: 217,
						wind_dir: "SW",
						pressure_mb: 1018,
						pressure_in: 30.07,
						precip_mm: 0,
						precip_in: 0,
						humidity: 87,
						cloud: 8,
						feelslike_c: 15.7,
						feelslike_f: 60.3,
						windchill_c: 15.7,
						windchill_f: 60.3,
						heatindex_c: 15.7,
						heatindex_f: 60.3,
						dewpoint_c: 13.6,
						dewpoint_f: 56.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.4,
						gust_kph: 0.7,
						uv: 1,
					},
					{
						time_epoch: 1688274000,
						time: "2023-07-02 02:00",
						temp_c: 15.5,
						temp_f: 59.9,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 0.9,
						wind_kph: 1.4,
						wind_degree: 295,
						wind_dir: "WNW",
						pressure_mb: 1018,
						pressure_in: 30.06,
						precip_mm: 0,
						precip_in: 0,
						humidity: 88,
						cloud: 10,
						feelslike_c: 15.5,
						feelslike_f: 59.9,
						windchill_c: 15.5,
						windchill_f: 59.9,
						heatindex_c: 15.5,
						heatindex_f: 59.9,
						dewpoint_c: 13.5,
						dewpoint_f: 56.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 1.6,
						gust_kph: 2.5,
						uv: 1,
					},
					{
						time_epoch: 1688277600,
						time: "2023-07-02 03:00",
						temp_c: 14.8,
						temp_f: 58.6,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.3,
						wind_kph: 2.2,
						wind_degree: 307,
						wind_dir: "NW",
						pressure_mb: 1018,
						pressure_in: 30.05,
						precip_mm: 0,
						precip_in: 0,
						humidity: 89,
						cloud: 12,
						feelslike_c: 14.8,
						feelslike_f: 58.6,
						windchill_c: 14.8,
						windchill_f: 58.6,
						heatindex_c: 14.8,
						heatindex_f: 58.6,
						dewpoint_c: 13,
						dewpoint_f: 55.4,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.5,
						gust_kph: 4,
						uv: 1,
					},
					{
						time_epoch: 1688281200,
						time: "2023-07-02 04:00",
						temp_c: 14.7,
						temp_f: 58.5,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.6,
						wind_kph: 2.5,
						wind_degree: 321,
						wind_dir: "NW",
						pressure_mb: 1018,
						pressure_in: 30.05,
						precip_mm: 0,
						precip_in: 0,
						humidity: 89,
						cloud: 14,
						feelslike_c: 14.7,
						feelslike_f: 58.5,
						windchill_c: 14.7,
						windchill_f: 58.5,
						heatindex_c: 14.7,
						heatindex_f: 58.5,
						dewpoint_c: 13,
						dewpoint_f: 55.4,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.7,
						gust_kph: 4.3,
						uv: 1,
					},
					{
						time_epoch: 1688284800,
						time: "2023-07-02 05:00",
						temp_c: 14.4,
						temp_f: 57.9,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.8,
						wind_kph: 2.9,
						wind_degree: 349,
						wind_dir: "N",
						pressure_mb: 1018,
						pressure_in: 30.06,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 14,
						feelslike_c: 14.4,
						feelslike_f: 57.9,
						windchill_c: 14.4,
						windchill_f: 57.9,
						heatindex_c: 14.4,
						heatindex_f: 57.9,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 3.1,
						gust_kph: 5,
						uv: 1,
					},
					{
						time_epoch: 1688288400,
						time: "2023-07-02 06:00",
						temp_c: 14.7,
						temp_f: 58.5,
						is_day: 0,
						condition: {
							text: "Clear",
							icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
							code: 1000,
						},
						wind_mph: 1.6,
						wind_kph: 2.5,
						wind_degree: 14,
						wind_dir: "NNE",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 90,
						cloud: 15,
						feelslike_c: 14.7,
						feelslike_f: 58.5,
						windchill_c: 14.7,
						windchill_f: 58.5,
						heatindex_c: 14.7,
						heatindex_f: 58.5,
						dewpoint_c: 13,
						dewpoint_f: 55.4,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.7,
						gust_kph: 4.3,
						uv: 1,
					},
					{
						time_epoch: 1688292000,
						time: "2023-07-02 07:00",
						temp_c: 16.1,
						temp_f: 61,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 1.3,
						wind_kph: 2.2,
						wind_degree: 352,
						wind_dir: "N",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 83,
						cloud: 6,
						feelslike_c: 16.1,
						feelslike_f: 61,
						windchill_c: 16.1,
						windchill_f: 61,
						heatindex_c: 16.1,
						heatindex_f: 61,
						dewpoint_c: 13.3,
						dewpoint_f: 55.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 1.8,
						gust_kph: 2.9,
						uv: 5,
					},
					{
						time_epoch: 1688295600,
						time: "2023-07-02 08:00",
						temp_c: 18,
						temp_f: 64.4,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 0.2,
						wind_kph: 0.4,
						wind_degree: 310,
						wind_dir: "NW",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 73,
						cloud: 4,
						feelslike_c: 18,
						feelslike_f: 64.4,
						windchill_c: 18,
						windchill_f: 64.4,
						heatindex_c: 18,
						heatindex_f: 64.4,
						dewpoint_c: 13.1,
						dewpoint_f: 55.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 0.2,
						gust_kph: 0.4,
						uv: 5,
					},
					{
						time_epoch: 1688299200,
						time: "2023-07-02 09:00",
						temp_c: 19.9,
						temp_f: 67.8,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 2,
						wind_kph: 3.2,
						wind_degree: 176,
						wind_dir: "S",
						pressure_mb: 1019,
						pressure_in: 30.08,
						precip_mm: 0,
						precip_in: 0,
						humidity: 63,
						cloud: 5,
						feelslike_c: 19.9,
						feelslike_f: 67.8,
						windchill_c: 19.9,
						windchill_f: 67.8,
						heatindex_c: 19.9,
						heatindex_f: 67.8,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 2.2,
						gust_kph: 3.6,
						uv: 5,
					},
					{
						time_epoch: 1688302800,
						time: "2023-07-02 10:00",
						temp_c: 21.2,
						temp_f: 70.2,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 3.6,
						wind_kph: 5.8,
						wind_degree: 186,
						wind_dir: "S",
						pressure_mb: 1018,
						pressure_in: 30.06,
						precip_mm: 0,
						precip_in: 0,
						humidity: 56,
						cloud: 5,
						feelslike_c: 21.2,
						feelslike_f: 70.2,
						windchill_c: 21.2,
						windchill_f: 70.2,
						heatindex_c: 24.4,
						heatindex_f: 75.9,
						dewpoint_c: 12,
						dewpoint_f: 53.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4,
						gust_kph: 6.5,
						uv: 6,
					},
					{
						time_epoch: 1688306400,
						time: "2023-07-02 11:00",
						temp_c: 24,
						temp_f: 75.2,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 4,
						wind_kph: 6.5,
						wind_degree: 205,
						wind_dir: "SSW",
						pressure_mb: 1017,
						pressure_in: 30.04,
						precip_mm: 0,
						precip_in: 0,
						humidity: 49,
						cloud: 5,
						feelslike_c: 25.2,
						feelslike_f: 77.4,
						windchill_c: 24,
						windchill_f: 75.2,
						heatindex_c: 25.2,
						heatindex_f: 77.4,
						dewpoint_c: 12.7,
						dewpoint_f: 54.9,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 4.7,
						gust_kph: 7.6,
						uv: 6,
					},
					{
						time_epoch: 1688310000,
						time: "2023-07-02 12:00",
						temp_c: 23.9,
						temp_f: 75,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 4.9,
						wind_kph: 7.9,
						wind_degree: 193,
						wind_dir: "SSW",
						pressure_mb: 1016,
						pressure_in: 30.01,
						precip_mm: 0,
						precip_in: 0,
						humidity: 45,
						cloud: 18,
						feelslike_c: 25,
						feelslike_f: 77,
						windchill_c: 23.9,
						windchill_f: 75,
						heatindex_c: 25,
						heatindex_f: 77,
						dewpoint_c: 11.4,
						dewpoint_f: 52.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 5.6,
						gust_kph: 9,
						uv: 6,
					},
					{
						time_epoch: 1688313600,
						time: "2023-07-02 13:00",
						temp_c: 24.3,
						temp_f: 75.7,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 5.8,
						wind_kph: 9.4,
						wind_degree: 183,
						wind_dir: "S",
						pressure_mb: 1016,
						pressure_in: 29.99,
						precip_mm: 0,
						precip_in: 0,
						humidity: 45,
						cloud: 21,
						feelslike_c: 25.2,
						feelslike_f: 77.4,
						windchill_c: 24.3,
						windchill_f: 75.7,
						heatindex_c: 25.2,
						heatindex_f: 77.4,
						dewpoint_c: 11.5,
						dewpoint_f: 52.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 6.7,
						gust_kph: 10.8,
						uv: 6,
					},
					{
						time_epoch: 1688317200,
						time: "2023-07-02 14:00",
						temp_c: 23.6,
						temp_f: 74.5,
						is_day: 1,
						condition: {
							text: "Sunny",
							icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
							code: 1000,
						},
						wind_mph: 8.5,
						wind_kph: 13.7,
						wind_degree: 164,
						wind_dir: "SSE",
						pressure_mb: 1015,
						pressure_in: 29.98,
						precip_mm: 0,
						precip_in: 0,
						humidity: 50,
						cloud: 22,
						feelslike_c: 25,
						feelslike_f: 77,
						windchill_c: 23.6,
						windchill_f: 74.5,
						heatindex_c: 25,
						heatindex_f: 77,
						dewpoint_c: 12.4,
						dewpoint_f: 54.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.8,
						gust_kph: 15.8,
						uv: 6,
					},
					{
						time_epoch: 1688320800,
						time: "2023-07-02 15:00",
						temp_c: 20.6,
						temp_f: 69.1,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 13.4,
						wind_kph: 21.6,
						wind_degree: 153,
						wind_dir: "SSE",
						pressure_mb: 1016,
						pressure_in: 30,
						precip_mm: 0,
						precip_in: 0,
						humidity: 69,
						cloud: 26,
						feelslike_c: 20.6,
						feelslike_f: 69.1,
						windchill_c: 20.6,
						windchill_f: 69.1,
						heatindex_c: 20.6,
						heatindex_f: 69.1,
						dewpoint_c: 14.7,
						dewpoint_f: 58.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 15.4,
						gust_kph: 24.8,
						uv: 6,
					},
					{
						time_epoch: 1688324400,
						time: "2023-07-02 16:00",
						temp_c: 18.9,
						temp_f: 66,
						is_day: 1,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
							code: 1003,
						},
						wind_mph: 11.4,
						wind_kph: 18.4,
						wind_degree: 155,
						wind_dir: "SSE",
						pressure_mb: 1017,
						pressure_in: 30.03,
						precip_mm: 0,
						precip_in: 0,
						humidity: 76,
						cloud: 25,
						feelslike_c: 18.9,
						feelslike_f: 66,
						windchill_c: 18.9,
						windchill_f: 66,
						heatindex_c: 18.9,
						heatindex_f: 66,
						dewpoint_c: 14.6,
						dewpoint_f: 58.3,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 13.2,
						gust_kph: 21.2,
						uv: 5,
					},
					{
						time_epoch: 1688328000,
						time: "2023-07-02 17:00",
						temp_c: 17.6,
						temp_f: 63.7,
						is_day: 1,
						condition: {
							text: "Patchy rain possible",
							icon: "//cdn.weatherapi.com/weather/64x64/day/176.png",
							code: 1063,
						},
						wind_mph: 10.5,
						wind_kph: 16.9,
						wind_degree: 155,
						wind_dir: "SSE",
						pressure_mb: 1018,
						pressure_in: 30.06,
						precip_mm: 0.1,
						precip_in: 0,
						humidity: 80,
						cloud: 81,
						feelslike_c: 17.6,
						feelslike_f: 63.7,
						windchill_c: 17.6,
						windchill_f: 63.7,
						heatindex_c: 17.6,
						heatindex_f: 63.7,
						dewpoint_c: 14.1,
						dewpoint_f: 57.4,
						will_it_rain: 1,
						chance_of_rain: 88,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 12.1,
						gust_kph: 19.4,
						uv: 4,
					},
					{
						time_epoch: 1688331600,
						time: "2023-07-02 18:00",
						temp_c: 16.7,
						temp_f: 62.1,
						is_day: 0,
						condition: {
							text: "Partly cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
							code: 1003,
						},
						wind_mph: 9.4,
						wind_kph: 15.1,
						wind_degree: 156,
						wind_dir: "SSE",
						pressure_mb: 1019,
						pressure_in: 30.09,
						precip_mm: 0,
						precip_in: 0,
						humidity: 82,
						cloud: 56,
						feelslike_c: 16.7,
						feelslike_f: 62.1,
						windchill_c: 16.7,
						windchill_f: 62.1,
						heatindex_c: 16.7,
						heatindex_f: 62.1,
						dewpoint_c: 13.7,
						dewpoint_f: 56.7,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 10.7,
						gust_kph: 17.3,
						uv: 1,
					},
					{
						time_epoch: 1688335200,
						time: "2023-07-02 19:00",
						temp_c: 16.3,
						temp_f: 61.3,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 8.9,
						wind_kph: 14.4,
						wind_degree: 155,
						wind_dir: "SSE",
						pressure_mb: 1020,
						pressure_in: 30.11,
						precip_mm: 0,
						precip_in: 0,
						humidity: 84,
						cloud: 70,
						feelslike_c: 16.3,
						feelslike_f: 61.3,
						windchill_c: 16.3,
						windchill_f: 61.3,
						heatindex_c: 16.3,
						heatindex_f: 61.3,
						dewpoint_c: 13.6,
						dewpoint_f: 56.5,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 10.3,
						gust_kph: 16.6,
						uv: 1,
					},
					{
						time_epoch: 1688338800,
						time: "2023-07-02 20:00",
						temp_c: 15.7,
						temp_f: 60.3,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 7.8,
						wind_kph: 12.6,
						wind_degree: 148,
						wind_dir: "SSE",
						pressure_mb: 1020,
						pressure_in: 30.11,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 80,
						feelslike_c: 15.7,
						feelslike_f: 60.3,
						windchill_c: 15.7,
						windchill_f: 60.3,
						heatindex_c: 15.7,
						heatindex_f: 60.3,
						dewpoint_c: 13.2,
						dewpoint_f: 55.8,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 9.6,
						gust_kph: 15.5,
						uv: 1,
					},
					{
						time_epoch: 1688342400,
						time: "2023-07-02 21:00",
						temp_c: 15.7,
						temp_f: 60.3,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 7.4,
						wind_kph: 11.9,
						wind_degree: 145,
						wind_dir: "SE",
						pressure_mb: 1020,
						pressure_in: 30.12,
						precip_mm: 0,
						precip_in: 0,
						humidity: 85,
						cloud: 78,
						feelslike_c: 15.7,
						feelslike_f: 60.3,
						windchill_c: 15.7,
						windchill_f: 60.3,
						heatindex_c: 15.7,
						heatindex_f: 60.3,
						dewpoint_c: 13.1,
						dewpoint_f: 55.6,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.7,
						gust_kph: 14,
						uv: 1,
					},
					{
						time_epoch: 1688346000,
						time: "2023-07-02 22:00",
						temp_c: 15.9,
						temp_f: 60.6,
						is_day: 0,
						condition: {
							text: "Cloudy",
							icon: "//cdn.weatherapi.com/weather/64x64/night/119.png",
							code: 1006,
						},
						wind_mph: 6.9,
						wind_kph: 11.2,
						wind_degree: 144,
						wind_dir: "SE",
						pressure_mb: 1020,
						pressure_in: 30.12,
						precip_mm: 0,
						precip_in: 0,
						humidity: 84,
						cloud: 87,
						feelslike_c: 15.9,
						feelslike_f: 60.6,
						windchill_c: 15.9,
						windchill_f: 60.6,
						heatindex_c: 15.9,
						heatindex_f: 60.6,
						dewpoint_c: 13.2,
						dewpoint_f: 55.8,
						will_it_rain: 0,
						chance_of_rain: 0,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 8.1,
						gust_kph: 13,
						uv: 1,
					},
					{
						time_epoch: 1688349600,
						time: "2023-07-02 23:00",
						temp_c: 15.8,
						temp_f: 60.4,
						is_day: 0,
						condition: {
							text: "Patchy rain possible",
							icon: "//cdn.weatherapi.com/weather/64x64/night/176.png",
							code: 1063,
						},
						wind_mph: 6.7,
						wind_kph: 10.8,
						wind_degree: 145,
						wind_dir: "SE",
						pressure_mb: 1020,
						pressure_in: 30.12,
						precip_mm: 0.1,
						precip_in: 0,
						humidity: 85,
						cloud: 85,
						feelslike_c: 15.8,
						feelslike_f: 60.4,
						windchill_c: 15.8,
						windchill_f: 60.4,
						heatindex_c: 15.8,
						heatindex_f: 60.4,
						dewpoint_c: 13.2,
						dewpoint_f: 55.8,
						will_it_rain: 1,
						chance_of_rain: 88,
						will_it_snow: 0,
						chance_of_snow: 0,
						vis_km: 10,
						vis_miles: 6,
						gust_mph: 7.8,
						gust_kph: 12.6,
						uv: 1,
					},
				],
			},
		],
	},
	alerts: {
		alert: [],
	},
};
